/* eslint-disable */
import validate from "@/assets/plugins/validate.min.js";
import Store from "@/core/services/store/index";
import moment from "moment";
import axios from 'axios';
import colorLib from '@kurkle/color';

const axiosInstance = axios.create();

export function loadObjectFromServer(id) {
    try {
        let constants ={}
        constants['APP_DATA'] = {
        "USER": 3,
        "TOKEN": "4c7097ee5a2547196e9f0f96565537224e4ef3a1",
        "SUBSCRIBED": "False"
        }

        constants['APP_ROUTES']={
            "SUBSCRIPTIONS_SUBSCRIBER_LIST": "/subscriptions/subscribers/list/",
            "SUBSCRIPTIONS_SUBSCRIBERS": "/subscriptions/subscribers/",
            "LOCATIONS": "/customers/locations/",
            "ACCOUNTS_LOGOUT": "/accounts/logout/",
            "ACCOUNTS_SETTINGS": "/accounts/settings/",
            "SUBSCRIPTIONS_SUBSCRIBER_LIST_SUBSCRIBERS": "/subscriptions/subscribers/list/subscribers/",
            "CAMPAIGNS_EMAIL_TEMPLATES": "/campaigns/email-templates/",
            "CAMPAIGNS": "/campaigns/campaigns/",
            "COMPANIES": "/customers/company/",
            "CUSTOMERS": "/customers",
            "DASHBOARD_REVENUE": "/pos/revenue/",
            "INVOICES": "/customers/invoices/",
            "COMPSET_LOCATIONS": "/customers/locations/compset",
            "ZIP_MAP_FEATURES": "/pos/heatmap/zip/",
            "MAP_FEATURES": "/pos/heatmap/spending/",
            "SPENDING_DATES": "/pos/heatmap/spending/dates/"
            
        }
            

        constants['APP_IMAGES'] ={
        "ABEN_LOGO_LIGHT": "https://staging-aben-assets.s3.ap-southeast-1.amazonaws.com/assets/img/Aben+Logo_Vertical_Gradient.png"
        }
        return constants[id];
    } catch (e) {
        console.log(e);
    }
}

export function money_format(value) {
    if (!value) value = 0;
    value = parseFloat(value);
    return "$" + value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
}

export function percentage_format(value) {
    return value
        ? value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,") + "%"
        : "";
}

export function percentage_format_segment(value) {
    return value
        ? value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,") + "%"
        : "0%";
}

export function roundOff(value) {
    
    return value ? value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,") : "";
}

export function roundOff2(value) {
    return value.toFixed(1).replace(/\d(?=(\d{3})+\.)/g, "$&,");
}

export function numberWithCommas(x) {
    return x ? x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : "";
}
export function generatePK(){
    let i = new Date().getTime();
    return i = i & 0xffff;
}
export function generateUUID() {
    // Public Domain/MIT
    var d = new Date().getTime(); //Timestamp
    var d2 = (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = Math.random() * 16; //random number between 0 and 16
        if (d > 0) {
            //Use timestamp until depleted
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            //Use microseconds since page-load if supported
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
}

// Response interceptor for API calls
axiosInstance.interceptors.response.use((response) => {
    return response
  }, async function (error) {
    if (error.response.status === 401) {     
        let code_challenge = generateCodeChallenge();
        localStorage.setItem("code_challenge", code_challenge);
        // localStorage.getItem("code_challenge");
        // invoke http://127.0.0.1:8000/o/authorize/?response_type=code&code_challenge=6P9KYPF7CNDPWPDJPYA4IVJPE5LJRH3WC2E2OV6PO8ILVKL2U60FNPTGCQ&client_id=6kff1AW1uMdOfOHuJqeevdhph9saUH89ue2Ub1Bm&redirect_uri=http://127.0.0.1:8000/noexist/callback
        let getAuthorizationCodeUrl = new URL(`${process.env.VUE_APP_AUTHORIZATION_URL}`+"/o/authorize/?response_type=code");
        var search_params = getAuthorizationCodeUrl.searchParams;
        search_params.set('code_challenge', code_challenge);
        search_params.set('client_id', `${process.env.VUE_APP_CLIENT_ID}`);      
        search_params.set('redirect_uri', `${process.env.VUE_APP_REDIRECT_URL}`);       
        getAuthorizationCodeUrl.search = search_params.toString();
        var new_url = getAuthorizationCodeUrl.toString();       
        window.location.replace(new_url);
    }
    return Promise.reject(error);
  });

export async function getData(url = "") {
    let tokenData = localStorage.getItem("tokenData")
    tokenData = JSON.parse(tokenData);  
    try {
        if('access_token' in tokenData){
            let access_token = tokenData['access_token'];
            let apiUrl = `${process.env.VUE_APP_API_URL}${url}`;
            let config = {
                method: "GET", // *GET, POST, PUT, DELETE, etc.
                mode: "cors", // no-cors, *cors, same-origin
                cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
                credentials: "same-origin", // include, *same-origin, omit
                headers: {
                    Authorization: `Bearer ${access_token}`,
                    "Content-Type": 'application/json'
                    
                },
                redirect: "follow", // manual, *follow, error
                referrerPolicy: "no-referrer" // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            }
            try { 
                let response = await axiosInstance.get(apiUrl,config);
                return response.data;
                
            } catch (e) {
                console.log('Error in getData:',e);
                return e;
            }    
        } 
        else{
            console.log("Unable to fetch access token")
            return null
        }
    } catch (error) {
        console.log("Error in access token fetch:",error)
        return null
    }
    
    
}

export async function postData(url = "", data = {}) {
    let tokenData = localStorage.getItem("tokenData")
    tokenData = JSON.parse(tokenData);  

    let access_token = tokenData['access_token'];
    
    let apiUrl = `${process.env.VUE_APP_API_URL}${url}`;
    let location_id = window.sessionStorage.getItem("selected_location")
        ? window.sessionStorage.getItem("selected_location")
        : null;

    let config = {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
            "Content-Type": "application/json",
            // Authorization: `${token}`
            Authorization: `Bearer ${access_token}`
            // "x-selected-aben-location": location_id
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        // body: JSON.stringify(data) // body data type must match "Content-Type" header
    }
    
    try { 
        let response = await axiosInstance.post(apiUrl,JSON.stringify(data),config);
        return response.data;
        
      } catch (e) {
        console.log('Error in postData:',e);
        return null;
      }    
    
}

export async function putData(url = "", data = {}) {
    let tokenData = localStorage.getItem("tokenData")
    tokenData = JSON.parse(tokenData);  

    let access_token = tokenData['access_token'];
    
    let apiUrl = `${process.env.VUE_APP_API_URL}${url}`;
    let config = {
        method: "PUT", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
            "Content-Type": "application/json",
            // Authorization: `${token}`
            Authorization: `Bearer ${access_token}`
            // "x-selected-aben-location": location_id
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        // body: JSON.stringify(data) // body data type must match "Content-Type" header
    }
    try { 
        let response = await axiosInstance.put(apiUrl,JSON.stringify(data),config);
        return response.data;
        
      } catch (e) {
        console.log('Error in putData:',e);
        return null;
      }    
    
}

export async function patchData(url = "", data = {}) {
    let tokenData = localStorage.getItem("tokenData")
    tokenData = JSON.parse(tokenData);  

    let access_token = tokenData['access_token'];
    
    let apiUrl = `${process.env.VUE_APP_API_URL}${url}`;
    let config = {
        method: "PATCH", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
            "Content-Type": "application/json",
            // Authorization: `${token}`
            Authorization: `Bearer ${access_token}`
            // "x-selected-aben-location": location_id
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        // body: JSON.stringify(data) // body data type must match "Content-Type" header
    }
    try { 
        let response = await axiosInstance.patch(apiUrl,JSON.stringify(data),config);
        return response.data;
        
      } catch (e) {
        console.log('Error in patchData:',e);
        return null;
      }    
}

export async function deleteData(url = "") {
    let tokenData = localStorage.getItem("tokenData")
    tokenData = JSON.parse(tokenData);  

    let access_token = tokenData['access_token'];
    
    let apiUrl = `${process.env.VUE_APP_API_URL}${url}`;
    let config = {
        method: "DELETE", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
            "Content-Type": "application/json",
            // Authorization: `${token}`
            Authorization: `Bearer ${access_token}`
            // "x-selected-aben-location": location_id
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer" // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    }
    try { 
        let response = await axiosInstance.delete(apiUrl,config);
        return response.data;
        
      } catch (e) {
        console.log('Error in deleteData:',e);
        return null;
      }   
}

export function getChartRevenues(data) {
    let revenues = [];
    for (let i = 0; i < data.length; i++) {
        let item = data[i];
        revenues.push(item.revenue);
    }
    return revenues;
}

export function getChartCategories(data) {
    let items = [];
    for (let i = 0; i < data.length; i++) {
        let item = data[i];
        items.push(item.period);
    }
    return items;
}

export function validatePresence(value) {
    return value != null ? value.trim() !== "" : false;
}

export function validateEmail(value) {
    return (
        value !== "" &&
        validate.single(value, {
            email: true
        }) === undefined
    );
}

export function validatePhoneNumber(value) {

    const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    return re.test(value);

}


export function validateURL(value) {
    let pattern = new RegExp(
        "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
        "i"
    ); // fragment locator
    return pattern.test(value);
}

export function noSpecialChar(value) {
    let re = new RegExp(/^[^*|\":<>[\]{}`\\()';@&$]+$/);
    return re.test(value);
}

export function validateZip(value) {
    return (
        validate.single(value, {
            numericality: {
                onlyInteger: true
            }
        }) === undefined && value.length === 5
    );
}

export function validatePassword(value) {
    return value === "" || value.length >= 8;
}

export function validateConfirmPassword(password, value) {
    if (password !== "") {
        // If something is in password field, do not allow
        // confirm_password to remain blank.
        return value === password;
    }
    return value === "";
}

export function isAuthenticated() {
    const APP_DATA = loadObjectFromServer("APP_DATA");
    return APP_DATA.SUBSCRIBED;
}

export function dateFormat(value) {
    return moment(value).format("lll");
}

export function dateFormatReadable(value) {
    return moment(value).format("MMM DD, YYYY");
}

export function timeFormatReadable(value) {
    return moment(value).format("hh:mm a");
}

export function dateFormatUnix(value) {
    return moment.unix(value).format("YYYY-MM-DD");
}

export function formatDatetime(value) {
    if (value) {
        // console.log(value);
        // console.log(typeof value);
        if (isNaN(value) && typeof value !== "object") {
            let dt = moment(value).format("YYYY-MM-DD hh:mm:ss");
            // console.log("dt", dt);
            return dt;
        } else if (typeof value === "object") {
            return value.toString();
        } else {
            return value;
        }
    }
    return null;
}

export const applyDrag = (arr, dragResult) => {
    const {removedIndex, addedIndex, payload} = dragResult;
    if (removedIndex === null && addedIndex === null) return arr;

    const result = [...arr];
    let itemToAdd = payload;

    if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0];
    }

    if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd);
    }

    return result;
};

export const generateItems = (count, creator) => {
    const result = [];
    for (let i = 0; i < count; i++) {
        result.push(creator(i));
    }
    return result;
};

export function getSelectedLocation() {
    return window.sessionStorage.getItem("selected_location")
        ? parseInt(window.sessionStorage.getItem("selected_location"))
        : null;
}

export function validateEmailAddress(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}


export function getIndex(obj) {
    // return Math.floor(Math.random() * obj.length);
    return 0;
}

export function setLocation(location) {
    window.sessionStorage.removeItem("selected_location");
    if (location) {  
        window.sessionStorage.setItem("selected_location", location);
    }
}

export function generateData(count, yrange) {
    var i = 0;
    var series = [];
    while (i < count) {
        var x = (i + 1).toString();
        var y =
            Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
        series.push({
            x: x,
            y: y
        });
        i++;
    }
    return series;
}

export function generateData2() {
    let yrange = {min: 0, max: 90};
    return Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
}

export function setupHeatmapSeries(result, metrics, baselines) {
    // console.log("metrics", metrics);
    // console.log("baselines", baselines);
    // console.log("result", result);
    let series = [];
    metrics.map(metric => {
        // console.log("metric", metric);
        let seriesObj = {};
        seriesObj.name = metric;
        let data = [];
        let temp_data = [];
        baselines.map(baseline => {
            // console.log("baseline", baseline);
            let result_cur = result
            let filter_results = result_cur.filter(obj => obj.baseline == baseline);
            
            // console.log("filter_results", filter_results);
            let total_sum = 0;
            for (let i = 0; i < filter_results.length; i++) {
                let obj = filter_results[i];
                // console.log("obj", obj);
                Object.keys(obj).forEach(key => {
                    if (key === metric) {
                        // console.log(key, obj[key]);
                        let sum = parseFloat(obj[key]);
                        total_sum = total_sum + sum;
                    }
                })
            }
            total_sum = filter_results.length > 0 ? total_sum/filter_results.length : 0;
            // console.log("baseline", baseline);
            temp_data.push({
                x: baseline,
                y: total_sum,
            });
            // data.push(temp_data);
        });
        seriesObj.temp_data = temp_data;
        seriesObj.data = temp_data;
        // seriesObj.data = data;
        series.push(seriesObj);
    });
    // console.log("series", series);
    // let new_series = setupHeatmapSeries(series);
    let new_series = [];
    series.map(item => {
        new_series.push({
            name: item.name,
            data: item.temp_data
        });
    });
    // console.log("new_series", new_series);
    return new_series;
}

export function toFixedNull(value, places) {
    return value === null ? null : parseFloat(value).toFixed(places);
}

export function capitalize(string) {
    return string[0].toUpperCase() + string.slice(1);
}
export function capitalizeWords(str) { // capitalize first letter of every word
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
    }
    return splitStr.join(' '); 
}
export function lastYearDate(d) {
    return moment(d)
        .subtract(1, "years")
        .format("YYYY-MM-DD");
}

export function getDaysBetweenDates(start_date, end_date) {
    let startDate = moment(start_date);
    let endDate = moment(end_date);
    var now = startDate.clone(),
        dates = [];
    while (now.isSameOrBefore(endDate)) {
        dates.push(now.format("MM/DD/YYYY"));
        now.add(1, "days");
    }
    return dates;
}

export function getDateRange(range) {
    try {
        let params = {};
        let start_date = moment()
            .add(-range, "days")
            .format("YYYY-MM-DD");
        let end_date = moment().format("YYYY-MM-DD");
        params.start_date = start_date;
        params.end_date = end_date;
        return params;
    } catch (e) {
        console.log(e);
    }
}

function randomStr(len, arr) {
    var ans = '';
    for (var i = len; i > 0; i--) {
        ans += 
          arr[Math.floor(Math.random() * arr.length)];
    }
    return ans;
}
function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function generateCodeChallenge(){
    let rn = getRandomInt(43,128);
    return randomStr(rn, '1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZ');
}


export const CHART_COLORS = {
    red: 'rgb(255, 99, 132)',
    orange: 'rgb(255, 159, 64)',
    yellow: 'rgb(255, 205, 86)',
    green: 'rgb(75, 192, 192)',
    blue: 'rgb(54, 162, 235)',
    purple: 'rgb(153, 102, 255)',
    grey: 'rgb(201, 203, 207)'
};



export function rand(min, max) {
    var seed = Date.now();
    min = min === undefined ? 0 : min;
    max = max === undefined ? 1 : max;
    seed = (seed * 9301 + 49297) % 233280;
    return min + (seed / 233280) * (max - min);
};


export function numbers(config) {
    
    var cfg = config || {};
    var min = cfg.min || 0;
    var max = cfg.max || 1;
    var from = cfg.from || [];
    var count = cfg.count || 8;
    var decimals = cfg.decimals || 8;
    var continuity = cfg.continuity || 1;
    var dfactor = Math.pow(10, decimals) || 0;
    var data = [];
    var i, value;

    for (i = 0; i < count; ++i) {
        value = (from[i] || 0) + rand(min, max);
        if (rand() <= continuity) {
            data.push(Math.round(dfactor * value) / dfactor);
        } else {
            data.push(null);
        }
    }

    return data;
  }

export function points(config) {
    const xs = numbers(config);
    const ys = numbers(config);
    return xs.map((x, i) => ({x, y: ys[i]}));
  };
  export function transparentize(value, opacity) {
    var alpha = opacity === undefined ? 0.5 : 1 - opacity;
    return colorLib(value).alpha(alpha).rgbString();
  };
